import React from 'react';
import './UniversalDrawerPopup.css';

function UniversalDrawerPopup({ visible, message, onClose, onAction, buttonLabel = 'OK' }) {
  if (!visible) return null;

  return (
    <div className="drawer-backdrop" onClick={onClose}>
      <div className="drawer-popup" onClick={(e) => e.stopPropagation()}>
        <p className="drawer-message">{message}</p>
        <div className="drawer-buttons">
          <button className="drawer-btn cancel" onClick={onClose}>Cancel</button>
          {onAction && (
            <button className="drawer-btn action" onClick={onAction}>{buttonLabel}</button>
          )}
        </div>
      </div>
    </div>
  );
}

export default UniversalDrawerPopup;
